import _ from 'lodash'
import MarkerWithLabel from 'marker-with-label'
import LatLng from './LatLng'
const Marker = MarkerWithLabel(google.maps)

const EventEmitter = require('events')

export default class StaticPoint extends EventEmitter {
    constructor(type = 'contact', id, data = {}){
        super()
        const defaultData = {
            label: "Ponto",
            color: "#429BF5"
        }
        this._id = id
        this._type = type
        this._data = _.assign(defaultData, data)
        this._marker = new Marker({
            position: {
                lat: 0,
                lng: 0
            },
            visible: false,
            icon: {
                path: !this._data.path  
                ? "M16.001 5c-4.216 0-7.714 3.418-7.634 7.634.029 1.578.719 2.824 1.351 4.024.242.461 6.264 10.332 6.264 10.332V27l.001-.007.002.007v-.01l6.531-10.377c.407-.703.793-1.771.793-1.771A7.631 7.631 0 0 0 16.001 5zM16 16.019a3.895 3.895 0 0 1-3.896-3.897A3.898 3.898 0 1 1 16 16.019z"
                : this._data.path,
                scale: 1,
                strokeColor: "#FFF",
                strokeWeight: 1,
                fillColor: this._data.color,
                fillOpacity: 1,
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(16, 20)
            },
            labelContent: this._data.label,
            labelAnchor: new google.maps.Point(60, -15),
            labelClass: "contact-label", // the CSS class for the label
            clickable: true,
            zIndex: 0
        })
        const vm = this
        this._marker.addListener('click', function() {
            vm.emit('click',{
                id: vm._id,
                type: vm._type,
                data: vm._data
            })
        })
    }
    setData(data){
        if(!this._data){
            this._data = data
        }
        else {
            this._data = _.assign(this._data,data)
        }
        this._data = _.assign(this._data,data)
        this._marker.setIcon({
            path: !this._data.path  
                ? "M16.001 5c-4.216 0-7.714 3.418-7.634 7.634.029 1.578.719 2.824 1.351 4.024.242.461 6.264 10.332 6.264 10.332V27l.001-.007.002.007v-.01l6.531-10.377c.407-.703.793-1.771.793-1.771A7.631 7.631 0 0 0 16.001 5zM16 16.019a3.895 3.895 0 0 1-3.896-3.897A3.898 3.898 0 1 1 16 16.019z"
                : this._data.path,
            scale: 1,
            strokeColor: "#FFF",
            strokeWeight: 1,
            fillColor: this._data.color,
            fillOpacity: 1,
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 20)
        })
        this._marker.labelContent = this._data.label
        this._marker.label.setContent()
    }
    setMap(map){
        this._marker.setMap(map)
        this._marker.setVisible(true)
    }
    setPosition(lat,lng){
        const latLng = new LatLng(lat,lng)
        this._marker.setPositionNotAnimated(latLng)
    }
    getMarker(){
        return this._marker
    }
    getType(){
        return this._type
    }
    getId(){
        return this._id
    }
    getData(){
        return this._data
    }
    remove(){
        google.maps.event.clearInstanceListeners(this._marker)
        this._marker.setMap(null)
        this.emit('remove',this._id)
    }
    update(){
    }
}